import { ReactNode } from 'react';

interface Props {
  name: string | ReactNode;
  label: string | ReactNode;
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
  disabled?: boolean;
  infoModal?: ReactNode;
}

const Toggle = ({ name, label, onChange, isChecked, disabled = false, infoModal }: Props) => {
  const handleToggle = () => {
    const newValue = !isChecked;
    onChange(newValue);
  };
  return (
    <div className={`inline-flex flex-1 flex-col gap-1 w-full`}>
      <div className={'flex justify-between items-end'}>
        {label && typeof label === 'string' ? (
          <span className="text-sm text-zinc-400">{label}</span>
        ) : (
          label
        )}
        {!!infoModal && infoModal}
      </div>
      <label
        className={`flex flex-1 items-center gap-4 justify-between border border-zinc-700 rounded-md px-4 py-3 ${
          disabled ? 'touch-none cursor-not-allowed' : 'cursor-pointer'
        }`}
      >
        {name && (
          <span
            className={`text-ellipsis text-nowrap overflow-hidden ${
              isChecked ? 'text-white' : 'text-zinc-400 '
            }`}
          >
            {name}
          </span>
        )}
        <div className="relative">
          <input
            type="checkbox"
            className="sr-only"
            checked={isChecked}
            onChange={handleToggle}
            disabled={disabled}
          />
          <div
            style={isChecked ? { backgroundColor: '#00D13B' } : {}}
            className={`w-10 h-6 bg-zinc-500 rounded-full shadow-inner transition-colors duration-300 ease-in-out`}
          ></div>
          <div
            className={`absolute w-4 h-4 bg-white rounded-full shadow top-1 left-1 transition-transform duration-300 ease-in-out ${
              isChecked ? 'transform translate-x-full' : ''
            }`}
          ></div>
        </div>
      </label>
    </div>
  );
};

export default Toggle;
